exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".f-logo-container {\n  bottom: 0;\n  color: #fff;\n  font: 10px \"AvenirNextLTPro-HeavyIt\", arial;\n  right: 0;\n  text-align: right;\n  padding: 1em 1em 2em 0;\n  position: absolute; }\n  .f-logo-container img {\n    margin-left: .5em;\n    vertical-align: middle;\n    width: 5vw; }\n\n@media (max-width: 768px) {\n  .f-logo-container {\n    display: none; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?{"includePaths":["absolute/path/a","absolute/path/b"]}!./src/js/components/FooterLogo.scss
// module id = 121
// module chunks = 0